import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AboutswiperService {

  constructor(private httpService: HttpClient) { }

  getAboutImages(){
    return this.httpService.get('../../assets/json/about/about_swiper.json');
  }
}
